<i18n>
{
  "fr": {
    "project-list-title": "Liste des projets",
    "id-label": "N°",
    "name-label": "Nom du projet",
    "create-label": "Date de création",
    "last-update-label": "Dernière modification",
    "actions-label": "Actions",
    "dialog-delete-confirm-title": "Supprimer",
    "dialog-delete-confirm-content": "Êtes-vous sûr de vouloir supprimer cet élément ?",
    "dialog-delete-confirm-button": "Oui",
    "dialog-delete-cancel-button": "Annuler",
    "create": "Créer"
  },
  "de": {
    "project-list-title": "Liste der Projekt",
    "id-label": "Nr.",
    "name-label": "Name des Projekt",
    "create-label": "Erstellungsdatum",
    "last-update-label": "Letzte Änderung",
    "actions-label": "Handeln",
    "dialog-delete-confirm-title": "Löschen",
    "dialog-delete-confirm-content": "Möchten Sie diesen Artikel wirklich löschen?",
    "dialog-delete-confirm-button": "Ja",
    "dialog-delete-cancel-button": "Abbrechen",
    "create": "Estellen"
  }
}
</i18n>

<template>
  <div id="project-lilst">

    <Header :title="$t('project-list-title')" />

    <md-content class="md-elevation-3 main-container">

      <md-table v-model="projects" md-card md-sort="companyName" @md-selected="onProjectSelect" md-fixed-header>
        <md-table-toolbar>
          <md-button @click="createProject"><md-icon>add_circle_outline</md-icon> {{ $t('create') }}</md-button>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
          <md-table-cell :md-label="$t('id-label')" md-sort-by="id">{{ item.id }}</md-table-cell>
          <md-table-cell :md-label="$t('name-label')" md-sort-by="name">{{ item.name }}</md-table-cell>
          <md-table-cell :md-label="$t('actions-label')"><md-button @click.stop.native="showDialogDelete = true; itemToDelete = item"><md-icon>delete_forever</md-icon></md-button></md-table-cell>
        </md-table-row>
      </md-table>

    </md-content>

    <md-dialog-confirm
      :md-active.sync="showDialogDelete"
      :md-title="$t('dialog-delete-confirm-title')"
      :md-content="$t('dialog-delete-confirm-content')"
      :md-confirm-text="$t('dialog-delete-confirm-button')"
      :md-cancel-text="$t('dialog-delete-cancel-button')"
      @md-cancel="showDialogDelete = false; itemToDelete = null"
      @md-confirm="onDeleteConfirm"
    />

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import Vue from 'vue'
import Project from '@/models/default/Project'

import Header from '@/components/header'
import Snackbar from '@/components/snackbar'

export default {
  name: 'ListProjects',
  components: {
    Header,
    Snackbar
  },
  data () {
    return {
      projects: [],
      showDialogDelete: false,
      itemToDelete: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadData().then(() => {

      }).catch(this.handleError)
    })
  },
  methods: {
    loadData () {
      return new Promise((resolve, reject) => {
        let toFetch = []
        toFetch.push(Project.list())

        Promise.all(toFetch).then((data) => {
          this.projects = data[0]
          resolve()
        }).catch(reject)
      })
    },
    onProjectSelect (project) {
      this.$router.push({
        name: 'detail-project',
        params: { id: project.id }
      })
    },
    createProject () {
      this.$router.push({
        name: 'new-project'
      })
    },
    deleteProject (project) {
      project.delete().then(() => {
        Vue.delete(this.projects, this.projects.indexOf(project))
      })
    },
    onDeleteConfirm () {
      this.deleteProject(this.itemToDelete)
      this.itemToDelete = null
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">

</style>
